import { Box, Button, Link, Spinner, Stack } from '@chakra-ui/react';
import { BlobProvider, PDFDownloadLink } from '@react-pdf/renderer';
import { memo, useRef } from 'react';
import { TextXS } from '../../Text/Index';
import { useGetClientData } from '../../../services/hooks/ClientData/useGetClientData';
import { IGetRegistration } from '../../../services/hooks/Registration/useGetRegistration';
import ProofOfSendingOfTitle from '../sendTitle';
import { IoPrint } from 'react-icons/io5';
import { IAspectsAndTopicsProps } from '../../../services/hooks/Titles/useGetTitlesTopicsData';
import { BsDownload } from 'react-icons/bs';
import { FaEye } from 'react-icons/fa';

interface IOwnProps {
  data?: IAspectsAndTopicsProps[];
  mode: 'print' | 'viewer' | 'download';
  registrationData?: IGetRegistration | null;
}

const TitleComprovantButton: React.FC<IOwnProps> = ({ data, mode, registrationData }) => {
  const ClientData = useGetClientData();

  const iframeRef = useRef<HTMLIFrameElement>(null);

  const handlePrint = (url: string | null) => {
    const iframe = iframeRef.current;

    if (iframe && url) {
      iframe.src = url;

      iframe.onload = () => {
        iframe.contentWindow?.focus();
        iframe.contentWindow?.print();
      };
    }
  };

  return (
    <Stack>
      <Box as="iframe" ref={iframeRef} id="pdfFrame" src="" display="none"></Box>
      {(mode !== 'download' && (
        <BlobProvider
          document={
            <ProofOfSendingOfTitle
              data={data}
              instituteLogo={ClientData?.data?.institute_logo}
              portrait_logo={ClientData?.data?.portrait_logo}
              registrationData={registrationData}
            />
          }
          // fileName="Comprovante_titulos.pdf"
        >
          {({ loading, url }) => {
            if (mode === 'viewer') {
              if (!url) return;
              return (
                <Button w={'fit-content'} leftIcon={<FaEye />} colorScheme="blue" variant={'outline'}>
                  <Link href={url} target="_blank">
                    {(loading && <Spinner />) || <TextXS>Visualizar comprovante</TextXS>}
                  </Link>
                </Button>
              );
            }
            return (
              <Button
                onClick={() => handlePrint(url)}
                w={'fit-content'}
                leftIcon={<IoPrint />}
                colorScheme="blue"
                variant={'outline'}
                size={'sm'}
              >
                Imprimir comprovante
              </Button>
            );
          }}
        </BlobProvider>
      )) || (
        <PDFDownloadLink
          document={
            <ProofOfSendingOfTitle
              data={data}
              instituteLogo={ClientData?.data?.institute_logo}
              portrait_logo={ClientData?.data?.portrait_logo}
              registrationData={registrationData}
            />
          }
          fileName="Comprovante_titulos.pdf"
        >
          {({ loading }) => {
            return (
              <Button w={'fit-content'} leftIcon={<BsDownload />} colorScheme="blue" variant={'outline'}>
                <Link>{(loading && <Spinner />) || <TextXS>Download do comprovante</TextXS>}</Link>
              </Button>
            );
          }}
        </PDFDownloadLink>
      )}
    </Stack>
  );
};

export default memo(TitleComprovantButton);
